import { styled } from "@mui/material";
import Chip, { ChipProps as MuiTagProps } from "@mui/material/Chip";

export const StyledLabelContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[0]};
`;

export const StyledLiveDot = styled("div")`
  height: 5px;
  width: 5px;
  border-radius: ${(props) => props.theme.wsc.radius.half};
  background-color: ${(props) => props.theme.wsc.palette.neutral[100]};
`;

export const StyledLiveLabel = styled("div")`
  font-size: ${(props) => props.theme.wsc.typography.body2bold.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body2bold.fontWeight};
`;

export const StyledLiveTag = styled(Chip)<MuiTagProps>`
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  border-radius: ${(props) => props.theme.wsc.radius.sm};
  background-color: ${(props) => props.theme.wsc.palette.warning[300]};
  height: 1.5rem;
  padding: ${(props) => props.theme.wsc.spacing[1]};

  .MuiChip-label {
    padding: 0;
  }
`;
